module.exports = __webpack_public_path__ + "img/shennandianlu.a77fcb90.png";